import useProject from '@API/project/useProject';
import { ViewItemData } from '@shared/components/ViewSelect/utils';
import { sortBy } from 'lodash';
import {
  expTemplateToProjectOptionItem,
  expTemplateToWorkspaceOptionItem
} from '../utils';
import useExpTemplateList from '@experiment-details/hooks/template/useExpTemplateList';

const useExpDetailsViewSelectOptions = () => {
  const { data: project } = useProject();
  const { data: templateList = [] } = useExpTemplateList();
  const savedTemplateList = templateList.filter(
    template => template.templateId && !template.personalView
  );

  const projectViewList: ViewItemData[] = savedTemplateList
    .filter(template => template.projectId === project?.projectId)
    .map(expTemplateToProjectOptionItem);
  const workspaceViewList: ViewItemData[] = savedTemplateList
    .filter(template => template.projectId !== project?.projectId)
    .map(expTemplateToWorkspaceOptionItem);

  return {
    projectViewList: sortBy(projectViewList, 'name'),
    workspaceViewList: sortBy(workspaceViewList, 'name')
  };
};

export default useExpDetailsViewSelectOptions;
